import { render, staticRenderFns } from "./ContextualMenu.vue?vue&type=template&id=485f3ffc"
import script from "./ContextualMenu.vue?vue&type=script&lang=js"
export * from "./ContextualMenu.vue?vue&type=script&lang=js"
import style0 from "./ContextualMenu.vue?vue&type=style&index=0&id=485f3ffc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports